import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Caret Down Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "m250.098 79.051-114.03 114.03c-4.455 4.46-11.682 4.46-16.136 0L5.902 79.052c-6.21-6.21-3.37-16.815 5.114-19.088a11.41 11.41 0 0 1 11.021 2.953L128 168.893 233.963 62.916c6.21-6.21 16.815-3.37 19.088 5.114a11.41 11.41 0 0 1-2.953 11.021" }, null, -1)
  ]))]))
}
export default { render: render }